const toRadians = deg => (deg * Math.PI) / 180;

const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371;
  const dLat = toRadians(lat2 - lat1);
  const dLng = toRadians(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

export const findClosestEntity = (subsidiaries = []) =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude, longitude } = position.coords;
        let closest = null;
        let minDistance = Infinity;

        subsidiaries.forEach(s => {
          const dist = calculateDistance(
            latitude,
            longitude,
            Number(s.latitude),
            Number(s.longitude)
          );
          if (dist < minDistance) {
            minDistance = dist;
            closest = s;
          }
        });

        resolve(closest);
      },
      err => {
        reject(err);
      }
    );
  });
